import React from "react";
import ResetPasswordForm from "@components/ResetPasswordForm/ResetPasswordForm";
import { StackLogo, Title } from "@pages/auth/login/Login.style";
import { LogoLetter } from "assets/icons/LogoLetter";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const RenitialisePassword = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  // 1️⃣ si token existe → décoder et récupérer l'email
  let emailFromToken;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      emailFromToken = decoded.email; // <-- récupère l'email dans le token
      console.log("🚀 ~ RenitialisePassword ~ emailFromToken:", emailFromToken);
    } catch (e) {
      console.error("Invalid token:", e);
    }
  }

  // 2️⃣ récupérer depuis query params
  const queryParams = new URLSearchParams(location.search);
  const emailFromParams = queryParams.get("email");

  // 3️⃣ récupérer depuis state
  const emailFromState = location.state?.email;

  // 4️⃣ choisir la bonne valeur
  const email = emailFromToken || emailFromParams || emailFromState || "";

  console.log("🚀 ~ RenitialisePassword ~ email:", email);

  return (
    <div>
      <StackLogo mt={4}>
        <LogoLetter />
        <Title>{t("Renitialiser votre mot de passe")}</Title>
      </StackLogo>

      <ResetPasswordForm email={email} />
    </div>
  );
};

export default RenitialisePassword;
